import {languages} from "@/domain/utils/languages";

const languageCodes = languages.map(lang => lang.code)

export function translate(field, currentLang) {
  if (!field) return ''

  if (field[currentLang]) return field[currentLang]

  for (const code of languageCodes) {
    if (code !== currentLang && field[code]) {
      return field[code]
    }
  }

  return ''
}
